import { useWindowSize } from '@kohler-dsm-library/kohler-core';
import { useState, useRef, useCallback, useEffect } from 'react';

const useResponsiveNav = (menuItems) => {
  const [visibleItems, setVisibleItems] = useState(menuItems);
  const [overflowItems, setOverflowItems] = useState([]);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const navRef = useRef(null);
  const containerRef = useRef(null);
  const moreButtonRef = useRef(null);
  const resizeTimeoutRef = useRef(null);
  const itemWidthsRef = useRef({});
  const windowSize = useWindowSize();
  const measureItemWidths = useCallback(() => {
    if (!navRef.current) return;
    const newWidths = {};
    navRef.current.childNodes.forEach((node) => {
      const element = node;
      if (element.id) {
        newWidths[element.id] = element.offsetWidth;
      }
    });
    itemWidthsRef.current = newWidths;
  }, []);
  const calculateVisibility = useCallback(() => {
    if (!navRef.current || !containerRef.current) return;
    const containerWidth = containerRef.current.clientWidth;
    const moreButtonWidth = moreButtonRef.current?.offsetWidth ? moreButtonRef.current?.offsetWidth + 15 : 70;
    let totalWidth = 0;
    const newVisibleItems = [];
    const newOverflowItems = [];
    for (const item of menuItems) {
      const itemWidth = itemWidthsRef.current[item.text] || 0;
      totalWidth += itemWidth;
      if (totalWidth < containerWidth - moreButtonWidth) {
        newVisibleItems.push(item);
      } else {
        newOverflowItems.push(item);
      }
    }
    setVisibleItems(newVisibleItems);
    setOverflowItems(newOverflowItems);
  }, [menuItems]);
  useEffect(() => {
    if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
    resizeTimeoutRef.current = setTimeout(() => {
      measureItemWidths();
      calculateVisibility();
    }, 200);
    return () => {
      if (resizeTimeoutRef.current) clearTimeout(resizeTimeoutRef.current);
    };
  }, [windowSize.width, measureItemWidths, calculateVisibility, containerRef.current?.offsetWidth]);
  return { visibleItems, overflowItems, isMoreOpen, setIsMoreOpen, navRef, containerRef, moreButtonRef };
};

export { useResponsiveNav as default };
